define('models/recurring_purchase',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for recurring purchases
            return  App.Config.apiBase + 'purchases/recurring/';
        },

        defaults: function () {
            return {
                basket: {},
                credit_card: ''
            };
        }
    });
});
